import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { toast } from 'react-toastify';
import loginImage from '../../assets/images/tennis-court.jpg';
import '../../assets/css/Login.css';

const CreateNewPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { email, code } = location.state || {};

    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const isStrongPassword = (password) => {
        const strongPasswordRegex = /^.{8}$/;
        return strongPasswordRegex.test(password);
    };


    const passwordsMatch = formData.password === formData.confirmPassword && formData.password.length > 0;
    const passwordValid = isStrongPassword(formData.password);

    const onCreateNewPassword = async () => {
        try {
            const data = {
                email: email,
                newPassword: formData.password,
            };
            const result = await apiHandler({
                url: endpoint.RESET_PASSWORD,
                method: "POST",
                data: data,
            });
            if (result.data.code !== '400' && result.data.code !== '500' && result.data.user_description !== "Invalid OTP") {
                toast.success("Password Created Successfully");
                navigate('/login');
            } else {
                toast.error(result.data.user_description);
            }
        } catch (error) {
            toast.error("Something went wrong");
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center" style={{
            backgroundImage: `url(${loginImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            height: '100%',
            width: '100%',
            position: 'absolute',
        }}>
            <div className="row" style={{ maxWidth: '60%', height: '400px' }}>
                <div className="border p-4" style={{ width: '407px', background: 'white', opacity: '0.9' }}>
                    <div className="p-3">
                        <div className='mt-3'>
                            <h4 className="mb-3 fs-4 create-new-txt">Create New Password</h4>
                            <CustomInput
                                label="Password"
                                placeholder="Create a Password"
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleInputChange}
                            />
                            {/* Password strength error */}
                            {formData.password.length > 0 && !passwordValid && (
                                <p style={{ color: 'red', fontSize: '14px' }}>
                                    Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.
                                </p>
                            )}
                        </div>
                        <CustomInput
                            placeholder="Confirm Password"
                            type="password"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleInputChange}
                        />
                        {/* Passwords do not match error */}
                        {formData.confirmPassword.length > 0 && !passwordsMatch && (
                            <p style={{ color: 'red', fontSize: '14px' }}>Passwords do not match</p>
                        )}
                        <div className="pt-4 pb-2">
                            <CustomButton
                                buttonText={'Continue'}
                                style={{
                                    width: '100%',
                                    height: '48px',
                                    borderRadius: '12px',
                                    background: '#006FFD',
                                    color: '#FFFFFF',
                                    border: 'none'
                                }}
                                onClick={onCreateNewPassword}
                                disabled={!passwordsMatch || !passwordValid}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateNewPassword;
